// extracted by mini-css-extract-plugin
export default {"whyItWorkSection":"WhyItWork_whyItWorkSection__NKKS2","whyItWorkTitle":"WhyItWork_whyItWorkTitle__+SxEZ","whyItWorkContainer":"WhyItWork_whyItWorkContainer__lvTLg"};